import api from '../utils/api';

export async function listMcpServers({ page = 1, perPage = 20, isActive } = {}) {
  const params = { page, per_page: perPage };
  if (isActive !== undefined && isActive !== null) {
    params.is_active = isActive;
  }
  const { data } = await api.get('/mcp-servers/', { params });
  return data;
}

export async function getMcpServer(id) {
  const { data } = await api.get(`/mcp-servers/${id}`);
  return data;
}

export async function createMcpServer(payload) {
  const { data } = await api.post('/mcp-servers/', payload);
  return data;
}

export async function updateMcpServer(id, payload) {
  const { data } = await api.put(`/mcp-servers/${id}`, payload);
  return data;
}

export async function deleteMcpServer(id) {
  const { data } = await api.delete(`/mcp-servers/${id}`);
  return data;
}

export async function testMcpServerConnection(id) {
  const { data } = await api.post(`/mcp-servers/${id}/test-connection`);
  return data;
}
